import { render, staticRenderFns } from "./personageOrderParticulars.vue?vue&type=template&id=08065fca&scoped=true&"
import script from "./personageOrderParticulars.vue?vue&type=script&lang=js&"
export * from "./personageOrderParticulars.vue?vue&type=script&lang=js&"
import style0 from "./personageOrderParticulars.vue?vue&type=style&index=0&id=08065fca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08065fca",
  null
  
)

export default component.exports